<div class="w-100 font-16">
    <div class="row d-flex">
        <div class="col-3" *ngIf="appointment && appointment.patientName!= null">
            <strong style="font-size:17px">Patient Name:</strong>&nbsp;
            <span [textContent]="appointment.patientName"></span>
        </div>
        <div class="col-3" *ngIf="appointment && appointment.umrNo!= null">
            &nbsp;
            <strong style="font-size:17px">UMR No  : </strong>&nbsp;
            <span [textContent]="appointment.umrNo"></span>
        </div>
        <div class="col-3" *ngIf="appointment && appointment.roomName!= null">
            <strong style="font-size:17px">Room Name:</strong>&nbsp;
            <span [textContent]="appointment.roomName"></span>
        </div>
        <!--<div class="col-3" *ngIf="patient && patient.patient.admissionId != null">
            <strong style="font-size:17px">AdmissionId:</strong>&nbsp;
            <span [textContent]="patient.patient.admissionId"></span>
        </div>-->
    </div>
    <div *ngIf="specialFeature && specialFeature.specialFeature" class="d-flex font-weight-medium w-100">
        <strong class="white-space-nowrap" style="color: darkblue;">Special Features &nbsp;:</strong>&nbsp;
        <span class="break-all" [textContent]="specialFeature.specialFeature"></span>
    </div>




</div>